import { useEffect, useRef } from 'react';
import { useActiveTheme } from 'shared/lib/mui';
import { collectMetadata } from 'shared/services/featurebase/metadata-collector';
import { ThemeModes } from 'shared/types/theme-modes';

import { useFeaturebaseScript } from './use-featurebase-script';
import { useUser } from './use-user';

export const useFeaturebaseSurveyWidget = () => {
  const { isReady, isError } = useFeaturebaseScript();
  const [activeTheme] = useActiveTheme();
  const user = useUser();
  const email = user?.email;

  const lastEmailRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isReady || isError || !email) {
      return;
    }

    if (lastEmailRef.current === email) {
      return;
    }

    if (window.Featurebase) {
      window.Featurebase('initialize_survey_widget', {
        organization: 'griply',
        placement: 'bottom-left',
        theme: activeTheme === ThemeModes.Dark ? 'dark' : 'light',
        locale: 'en',
        email,
        name: user?.name,
        metadata: collectMetadata(),
      });

      lastEmailRef.current = email;
    }
  }, [isReady, isError, email, user?.name, activeTheme]);
};
